"use client";
import { FC, useEffect, useState } from "react";

import { useLocalizedRouterServer } from "@ctv/shared-core/src";

import AuthLoading from "./AuthLoading";
import { useAuth } from "./CognitoAuthContext";
import { useFetchCorporateSettings } from "./apis";

export default function withAuth<T>(Component: FC<T>) {
  function Auth(props: any) {
    const [isFetchCorporateSettings, setIsFetchCorporateSettings] =
      useState(true);

    const { isAuthenticated, isLoading, updateUser } = useAuth();
    const router = useLocalizedRouterServer();
    const fetchCorporateSettings = useFetchCorporateSettings();

    // If user is not logged in, return login component
    useEffect(() => {
      if (!isAuthenticated && !isLoading) {
        router.push("/");
      }

      if (isAuthenticated) {
        fetchCorporateSettings()
          .then((res) => {
            if (res.success) {
              updateUser(res.data);
            }
          })
          .finally(() => setIsFetchCorporateSettings(false));
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps -- only run when isAuthenticated, isLoading changes
    }, [isAuthenticated, isLoading]);

    if (isLoading || !isAuthenticated || isFetchCorporateSettings) {
      return <AuthLoading />;
    }

    // If user is logged in, return original component
    return <Component {...props} />;
  }

  return Auth;
}
